import { setupGlobals, setupClientGlobals } from '../util/GlobalSetup.js';
setupClientGlobals();
setupGlobals();

import '../chunks/polyfills.js';

import { init as initDiscover } from '../controllers/discover.js';
import { switchLocale } from '../i18n/discover.i18n.js';
import '../chunks/shared-webcomponents.js';
import '../chunks/discover-webcomponents.js';
import '../chunks/family-card-webcomponents.js';
import 'angular';
import '../angular_apps/discover.js';

import { refreshCoachmarks } from '../util/coachmark_helpers.js';
import { initI18n } from '../util/i18n_util.js';
import { initFlipper } from '../util/flipper.js';

initI18n(switchLocale);
initDiscover();
initFlipper();

refreshCoachmarks();
